import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import {
  Aangever,
  Aangifte, BokkzAlgDataService,
  Box3InkomenUitSparenEnBeleggen, IncomeTaxEntity,
  OmschrijvingEnBedrag
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SPINNER_TIMEOUT} from "../../gedeelde-componenten/gedeelde-componenten.component";
import { Event, NavigationEnd, Router } from "@angular/router";
import { filter, Subscription } from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector:
    'snelstart-venture-fiscaal-feature-box3-vorderingen-of-contant-geld',
  templateUrl: './box3-vorderingen-of-contant-geld.component.html',
  styleUrls: ['./box3-vorderingen-of-contant-geld.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class Box3VorderingenOfContantGeldComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription | undefined;
  private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
  private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;

    public vorderingenOfContantGeld = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,private router: Router, private fb: FormBuilder) {
        this.vorderingenOfContantGeld = this.fb.group({
            box3VorderingenOfContantGeld:
                this.fb.array<Box3InkomenUitSparenEnBeleggen>([])
        })
    }

    get box3VorderingenOfContantGeld(): FormArray {
        return this.vorderingenOfContantGeld.get('box3VorderingenOfContantGeld') as FormArray;
    }

    addRijVorderingenOfContantGeld(): void {
        this.box3VorderingenOfContantGeld.push(this.createVorderingenOfContantGeldFormGroup()
        )
    }

    verwijderRijVorderingenOfContantGeld(index: number): void {
        this.box3VorderingenOfContantGeld.removeAt(index);
        this.vorderingenOfContantGeld.updateValueAndValidity()
        this.vorderingenOfContantGeld.markAsDirty()
        this.saveForm()
    }



    createVorderingenOfContantGeldFormGroup(vordering?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: vordering ? vordering.omschrijving : undefined,
            bedrag: vordering ? vordering.bedrag : undefined,
        } as OmschrijvingEnBedrag))
    }

    ngOnInit(): void {
    this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.vorderingenOfContantGeld.dirty
  }

    private updateForm(): void {
        const vorderingOfContantGeldLijst = this.incomeTaxEntity?.aangifte?.box3?.vorderingenOfContantGeld || [];
        const formArray = this.vorderingenOfContantGeld.get('box3VorderingenOfContantGeld') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > vorderingOfContantGeldLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < vorderingOfContantGeldLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(vorderingOfContantGeldLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createVorderingenOfContantGeldFormGroup(vorderingOfContantGeldLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity?.aangifte,
                box3: {
                    ...this.incomeTaxEntity?.aangifte?.box3,
                    vorderingenOfContantGeld: this.vorderingenOfContantGeld.value.box3VorderingenOfContantGeld
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        }, 200)
    }

    getOWRDialogTitel(i: number): string {
        const omschrijving = this.box3VorderingenOfContantGeld.controls[i]?.get('omschrijving')?.value;
        const jaar = this.incomeTaxEntity.year;

        if (!omschrijving) {
            return 'Werkelijk rendement overig bezit';
        }

        return `Werkelijk rendement: ${omschrijving}`;
    }
}
